<template>
  <div v-if="show" class="col-xs-12 col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
      v-mask="'##/##/####'"
      masked="true"
    />
  </div>
</template>

<script>
import verificaTipoPessoa from "../../../../mixins/protocolo/verificaTipoPessoa";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  name: "c-protocolo-date",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    id: String
  },
  mixins: [verificaTipoPessoa],
  data() {
    return {
      show: true
    };
  },
  asyncComputed: {
    verificar() {
      if (this.id == 47) {
        this.show = !this.$isJuridica(this.formValues);
      }
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Date.vue